export const REST_PUBLIC_URI =
  process.env.REACT_APP_BACKEND_API || "http://localhost:8000";

export const WEB_CLIENT_PUBLIC_URI =
  process.env.REACT_APP_WEB_CLIENT || "https://uat.richerbetter.com";
